import React from "react";
import { fmtDateTime } from "@/lib/format";

const RedemptionRow = ({ r }) => (
  <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-border last:border-0" data-testid={`redemption-row-${r.redemption_id}`}>
    <div className="min-w-0">
      <div className="font-medium truncate">{r.reward_title}</div>
      <div className="text-xs text-muted-foreground">{r.partner_name} · {fmtDateTime(r.created_at)}</div>
    </div>
    <div className="text-right shrink-0">
      <div className="font-mono text-xs bg-secondary/60 px-2 py-0.5 rounded">{r.code}</div>
      <div className="text-[10px] uppercase tracking-widest font-semibold text-muted-foreground mt-0.5">{r.status}</div>
    </div>
  </div>
);

export default RedemptionRow;
